import React from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Divider } from '@mui/material';
import { useTheme } from '@emotion/react';

// Helper function to format date
const formatDate = (date) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString(undefined, options);
};

const TrainingList = ({ trainings, selectedId, setTitle, setTraining, setSelectedId }) => {
  const theme = useTheme();

  // Group trainings by their series
  const groupedTrainings = trainings.reduce((acc, curr) => {
    // Group by series, if not exists create a new array for this series number
    if (!acc[curr.series]) {
      acc[curr.series] = [];
    }
    acc[curr.series].push(curr);
    return acc;
  }, {});

  return (
    <Box sx={{ backgroundColor: theme.palette.background.default, padding: 1, borderRadius: 2, margin: 1, marginTop: 0 }}>
      {Object.keys(groupedTrainings).map((seriesNumber) => (
        <div key={seriesNumber}>
          {/* Series Heading */}
          <Typography
            sx={{
              fontSize: 14,
              textAlign: 'left',
              marginLeft: 1,
              marginTop: 2,
              color: theme.palette.text.primary,
            }}
            variant='button'
          >
            <b>Series {seriesNumber}</b>
          </Typography>

          {/* List of Trainings for this series */}
          <List>
            {groupedTrainings[seriesNumber]
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((i, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    sx={{
                      backgroundColor: i.id === selectedId ? '#0177b625' : '',
                      borderRadius: 2,
                    }}
                    disablePadding
                  >
                    <ListItemButton onClick={() => { setTitle(i.title); setTraining(i); setSelectedId(i.id); }}>
                      <ListItemText
                        sx={{ color: theme.palette.text.primary }}
                        primary={
                          <div>
                            <Typography sx={{ fontSize: 12, fontWeight: 'bold', color: 'gray' }}>
                              {formatDate(i.date)}
                            </Typography>
                            <Typography sx={{ fontSize: 15, fontWeight: 'bold' }}>
                              {i.title ? i.title : i.appName}
                            </Typography>
                          </div>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                  <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
                </React.Fragment>
              ))}
          </List>
        </div>
      ))}
    </Box>
  );
};

export default TrainingList;
